var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject, transient } from "aurelia-dependency-injection";
import * as Enumerable from "linq";
import { computedFrom } from "aurelia-binding";
import { bindable } from "aurelia-templating";
import { I18N } from 'aurelia-i18n';
import { DataType, ItemSource, SourceType } from "../../../../../models/queries/queries.models";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { NotifyPropertyChangedBase, Reflection } from "../../../../../utilities/reflection";
import { GenesisRouterConstants } from "../../../../../configuration/router.constants";
import { PermissionEntity } from "../../../../../models/manage/permissions.models";
import { Router } from "aurelia-router";
import { DialogServiceConstants } from "../../../../../constants/basics/dialog.constants";
import { UserClientService } from "../../../../../services/authentication/user-client.service";
import { UserClaimsService } from "../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../constants/authentication/claims";
var ManageRoles = /** @class */ (function (_super) {
    __extends(ManageRoles, _super);
    function ManageRoles(dialogClient, router, userClientService, element, i18N, userClaimService) {
        var _this = _super.call(this) || this;
        _this.dialogClient = dialogClient;
        _this.router = router;
        _this.userClientService = userClientService;
        _this.element = element;
        _this.i18N = i18N;
        _this.userClaimService = userClaimService;
        _this.isAnd = true;
        _this.page = 0;
        _this.recordsPerPage = 10;
        return _this;
    }
    ManageRoles.prototype.currentDepartmentRolesChanged = function () {
        this.roleInEdit = null;
        this.isEditCreate = false;
    };
    ManageRoles.prototype.canAccessPermissions = function () {
        // return UserRoleAndClaimsHelper.HasAccessPermissionsPagePermission(this.userClientService.currentUser.allowedClaims);
        return this.userClaimService.hasPermission(Claims.CanAccessPermissions);
    };
    ManageRoles.prototype.itemSelected = function (event) {
        if (event.detail.item)
            this.setRole(event.detail.item);
    };
    ManageRoles.prototype.goToPermissions = function () {
        this.router.navigateToRoute(GenesisRouterConstants.RouteNames.ManagePermissions, {
            type: PermissionEntity.Role,
            id: this.roleInEdit.roleId,
            name: this.roleInEdit.roleName
        });
    };
    ManageRoles.prototype.goToValidations = function () {
        this.router.navigateToRoute(GenesisRouterConstants.RouteNames.ManageValidations, {
            type: PermissionEntity.Role,
            id: this.roleInEdit.roleId,
            name: this.roleInEdit.roleName
        });
    };
    ManageRoles.prototype.edit = function () {
        this.lastEditedRoleName = this.roleInEdit.roleName;
        this.isEditCreate = true;
        this.roleInEdit.isEditable = true;
        this.setRole(this.roleInEdit);
        this.onPropertyChanged(function (x) { return x.roles; });
    };
    Object.defineProperty(ManageRoles.prototype, "onlyOneSelected", {
        get: function () {
            if (this.currentDepartmentRoles && this.roleInEdit) {
                return true;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManageRoles.prototype, "anyIsSelected", {
        get: function () {
            if (this.currentDepartmentRoles && this.roleInEdit) {
                return true;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    ManageRoles.prototype.showDelete = function () {
        this.dialogClient.show(DialogServiceConstants.URLs.DeleteModal, this);
    };
    Object.defineProperty(ManageRoles.prototype, "roles", {
        get: function () {
            var _this = this;
            var query = Enumerable.from(this.currentDepartmentRoles).skip(this.page * this.recordsPerPage)
                .take(this.recordsPerPage);
            if (this.searchTextInUse) {
                if (this.isAnd)
                    query = query.where(function (x) { return x.roleName.toLowerCase().indexOf(_this.searchTextInUse.toLowerCase()) !== -1; });
                else {
                    var text = this.searchTextInUse.toLowerCase().split(" ");
                    query = query.where(function (x) { return Enumerable.from(text).any(function (a) { return x.roleName.toLowerCase().indexOf(a) !== -1; }); });
                }
            }
            var source = query.toArray();
            return { source: source, sourceType: SourceType.Collection, columns: this.getColumns() };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManageRoles.prototype, "pages", {
        get: function () {
            return this.currentDepartmentRoles ? Math.ceil(this.currentDepartmentRoles.length / this.recordsPerPage) : 1;
        },
        enumerable: false,
        configurable: true
    });
    ManageRoles.prototype.getColumns = function () {
        return [
            {
                sortOrder: 0,
                columnOrder: 0,
                name: "roleName",
                dataType: DataType.Default,
                title: this.i18N.tr('role-name-text')
            },
            {
                sortOrder: 1,
                columnOrder: 1,
                name: "isManager",
                dataType: DataType.Boolean,
                title: this.i18N.tr("manager")
            },
        ];
    };
    Object.defineProperty(ManageRoles.prototype, "hasPervious", {
        get: function () {
            return this.page > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManageRoles.prototype, "hasNext", {
        get: function () {
            return this.page < this.pages - 1;
        },
        enumerable: false,
        configurable: true
    });
    ManageRoles.prototype.setRole = function (role) {
        this.roleInEdit = role;
    };
    ManageRoles.prototype.getEmptyDepartment = function () {
        return {
            roleId: 0,
            roleName: "",
            departmentId: this.departmentId,
            isSelected: false,
            permissions: [],
            roleUsers: [],
            isManager: false,
            roleDashboards: []
        };
    };
    ManageRoles.prototype.newRole = function () {
        var role = this.getEmptyDepartment();
        this.currentDepartmentRoles.push(role);
        this.onPropertyChanged(function (x) { return x.roles; });
        role.isEditable = true;
        this.setRole(role);
        this.isEditCreate = true;
    };
    ManageRoles.prototype.save = function () {
        if (this.roleInEdit) {
            this.roleInEdit.isEditable = false;
        }
        var changeEvent = new CustomEvent('save', {
            bubbles: true
        });
        this.element.dispatchEvent(changeEvent);
        this.isEditCreate = false;
    };
    ManageRoles.prototype.delete = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var e_1, _a;
            var selectedItems = [_this.roleInEdit];
            try {
                for (var selectedItems_1 = __values(selectedItems), selectedItems_1_1 = selectedItems_1.next(); !selectedItems_1_1.done; selectedItems_1_1 = selectedItems_1.next()) {
                    var item = selectedItems_1_1.value;
                    var index = _this.currentDepartmentRoles.indexOf(item);
                    _this.currentDepartmentRoles.splice(index, 1);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (selectedItems_1_1 && !selectedItems_1_1.done && (_a = selectedItems_1.return)) _a.call(selectedItems_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            _this.dialogClient.hide();
            // this needs to be async
            setTimeout(function () {
                _this.save();
                resolve();
            });
        });
    };
    ManageRoles.prototype.search = function () {
        this.roleInEdit = null;
        this.page = 0;
        this.searchTextInUse = this.searchText;
        this.isEditCreate = false;
    };
    ManageRoles.prototype.next = function () {
        this.page = this.page + 1;
        this.isEditCreate = false;
    };
    ManageRoles.prototype.pervious = function () {
        this.page = this.page - 1;
        this.isEditCreate = false;
    };
    ManageRoles.prototype.cancel = function () {
        this.roleInEdit.isEditable = false;
        if (this.roleInEdit.roleId === 0) // this means its new
         {
            var index = this.currentDepartmentRoles.indexOf(this.roleInEdit);
            this.currentDepartmentRoles.splice(index, 0);
        }
        else {
            this.roleInEdit.roleName = this.lastEditedRoleName;
        }
        this.isEditCreate = false;
        if (this.roleInEdit && this.roleInEdit.roleId == 0) {
            var index = this.currentDepartmentRoles.indexOf(this.roleInEdit);
            if (index > -1) {
                this.currentDepartmentRoles.splice(index, 1);
            }
        }
        this.onPropertyChanged(function (x) { return x.roles; });
    };
    ManageRoles.prototype.removeDashboardRole = function (item) {
        var index = this.roleInEdit.roleDashboards.indexOf(item);
        this.roleInEdit.roleDashboards.splice(index, 1);
    };
    ManageRoles.prototype.addDashboardRole = function () {
        this.roleInEdit.roleDashboards.push({
            roleDashboardId: 0,
            roleId: this.roleInEdit.roleId,
            dashboardId: 0
        });
    };
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], ManageRoles.prototype, "departmentId", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], ManageRoles.prototype, "currentDepartmentRoles", void 0);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.currentDepartmentRoles; }), Reflection.getPropertyPath(function (x) { return x.page; }), Reflection.getPropertyPath(function (x) { return x.recordsPerPage; }), Reflection.getPropertyPath(function (x) { return x.searchTextInUse; }), Reflection.getPropertyPath(function (x) { return x.isAnd; }), Reflection.getPropertyPath(function (x) { return x.changes.roles; })),
        __metadata("design:type", ItemSource),
        __metadata("design:paramtypes", [])
    ], ManageRoles.prototype, "roles", null);
    ManageRoles = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [DialogClientService,
            Router,
            UserClientService,
            Element,
            I18N,
            UserClaimsService])
    ], ManageRoles);
    return ManageRoles;
}(NotifyPropertyChangedBase));
export { ManageRoles };
